<template>
    <div
    v-for="(lineGroup, index) in overviewOfSelectedInfoParser(selectedProduct, currency, accountsBalances, formData)"
    :key="`lineGroup${index}`"
    :style="{'width': '100%'}">
        <divider-generic
        :icon="lineGroup.icon"
        :title="lineGroup.label"
        :applyBorder="index !== 0"
        style="margin-bottom: 24px;"/>
        <!-- Text Block for each line -->
        <text-block-generic
        v-for="line in lineGroup.lines"
        :key="`lineGroupLine${line,id}`"
        :params="line"
        :mask="line.mask"/>
    </div>
</template>

<script setup>
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import DividerGeneric from '@/components/generic/dividers/Generic'

/* Assets and Helpers */
import { overviewOfSelectedInfoParser } from '@/assets/scripts/parsers/savings.js'

/* Emmitters */
const emit = defineEmits(['scrollTo'])

/* props received
@formData { Object } - object with info for our current form
@currency { String }
@selectedProduct { Array } - data that comes from the previous feature
@accountsBalances { Array } - list of accounts balances
*/
const props = defineProps({
    formData: Object,
    currency: String,
    selectedProduct: Array,
    accountsBalances: Array
})

emit('scrollTo', 0)

</script>

<style lang="scss" scoped>
.text-blocks-wrapper {
    margin-bottom: 24px;

    &:last-of-type {
        margin-bottom: 0;
    }
}
</style>
